export default "/imgs/telegram_button.svg"